import { render } from "./SignupView.vue?vue&type=template&id=9dc2557a"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corrieleech/Actualize/booksmart-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__